import { Actions } from '#base/Canvas/Actions.js';
import { DesignerDispatch } from '#base/Canvas/Dispatch.js';
import classNames from 'classnames';
import { useContext } from 'react';
import { BsArrowLeft, BsArrowRight } from 'react-icons/bs';

const GroupMembersRenderer = ({ elements: _elements, className = '' }) => {
  const dispatch = useContext(DesignerDispatch);

  const elements = (_elements && !!_elements.toJS && _elements.toJS()) || [];

  const group = elements.find((element) => element.isGroup);

  if (!group || !group.data || group.data.length < 1) return null;

  const activeIndex = group?.data?.findIndex((member) => member.active);

  const onDotClick = (index) => {
    dispatch(Actions.setActiveGroup(index));
  };

  const onArrowClick = (direction) => () => {
    let newActiveIndex = activeIndex;
    if (direction === 'prev') {
      newActiveIndex = activeIndex - 1;
      if (newActiveIndex < 0) newActiveIndex = group.data.length - 1;
    } else if (direction === 'next') {
      newActiveIndex = activeIndex + 1;
      if (newActiveIndex >= group.data.length) newActiveIndex = 0;
    }

    dispatch(Actions.setActiveGroup(newActiveIndex));
  };

  return (
    <div className={classNames('', className)}>
      <div className='t-flex t-w-full t-items-center t-justify-center t-gap-7'>
        <BsArrowLeft
          size={20}
          className='t-cursor-pointer t-text-brand-black t-opacity-100 t-transition t-duration-200 hover:t-opacity-70'
          onClick={onArrowClick('prev')}
        />
        <div className='t-flex t-items-center t-justify-center t-gap-2'>
          {group.data.map((member, idx) => (
            <Dot key={idx} isActive={member.active} onClick={() => onDotClick(idx)} />
          ))}
        </div>
        <BsArrowRight
          size={20}
          className='t-cursor-pointer t-text-brand-black t-opacity-100 t-transition t-duration-200 hover:t-opacity-70'
          onClick={onArrowClick('next')}
        />
      </div>

      {activeIndex >= 0 && (
        <>
          <p className='t-mb-0 t-mt-6 t-flex t-w-full t-items-center t-justify-center t-gap-1 t-text-center t-text-base t-font-bold t-text-brand-black'>
            <span>{group.data[activeIndex].data}</span>{' '}
            {group.data[activeIndex].decoration && <span>{group.data[activeIndex].decoration}</span>}
          </p>

          <p className='t-mt-2 t-text-center t-text-sm t-font-normal t-text-brand-black'>
            ({activeIndex + 1} of {group.data.length})
          </p>
        </>
      )}
    </div>
  );
};

const Dot = ({ isActive, onClick }) => {
  return (
    <div
      onClick={onClick}
      className={classNames(
        't-h-2 t-w-2 t-cursor-pointer t-rounded-full t-border t-border-brand-black t-transition t-duration-200',
        {
          't-bg-brand-black': isActive,
          't-bg-transparent hover:t-bg-brand-black': !isActive,
        }
      )}></div>
  );
};

export default GroupMembersRenderer;
